import React, { useCallback } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import ActionLink from "@churchofjesuschrist/eden-action-link";
import { ChevronLeft } from "@churchofjesuschrist/eden-icons";
import { useMediaQuery } from "@churchofjesuschrist/eden-media-query";
import { borderColorPrimary, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { Text5 } from "@churchofjesuschrist/eden-text";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx as _jsx } from "react/jsx-runtime";
const Chevron = styled(ChevronLeft).withConfig({
  componentId: "sc-wkaro-0"
})(["", ""], dir("rtl")`
     transform: scale(-1);
  `);
const CrumbList = styled.ol.withConfig({
  componentId: "sc-wkaro-1"
})(["list-style:none;display:flex;flex-wrap:wrap;padding:0;margin:0;"]);
const ListItem = styled(Text5).withConfig({
  componentId: "sc-wkaro-2"
})(["::after{content:\"/\";margin:0 ", ";color:", ";}"], spacing8, borderColorPrimary);
const Breadcrumbs = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  const [match] = useMediaQuery(useCallback(x => x, []), "(min-width: 400px)");
  const arrayedChildren = React.Children.toArray(children);
  if (arrayedChildren.length === 1) {
    return null;
  } else if (match) {
    return /*#__PURE__*/_jsx("nav", {
      ...rest,
      children: /*#__PURE__*/_jsx(CrumbList, {
        children: arrayedChildren.map((child, index) => index === arrayedChildren.length - 1 ? /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(Text5, {
            ...child.props,
            href: null
          })
        }, "lastCrumb") : /*#__PURE__*/_jsx(ListItem, {
          forwardedAs: "li",
          children: child
        }, child.props.href))
      })
    });
  } else {
    const lastChild = arrayedChildren[arrayedChildren.length - 2];
    return /*#__PURE__*/_jsx(ActionLink, {
      href: lastChild.props.href,
      Icon: Chevron,
      children: lastChild.props.children
    });
  }
};
Breadcrumbs.propTypes = {
  /** The links, they should be `<a>` elements. You must include at least two `<a>` elements otherwise the component will return null. */
  children: PropTypes.node.isRequired
};
export default Breadcrumbs;